<div class="sticky top-[72px] w-full bg-white p-4 shadow-lg" style="z-index: 15">
    <!-- Filter Line -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4 items-center">
        <!-- Filter Buttons -->
        <div class="flex gap-2 justify-center lg:justify-start items-center">
            @if(canReadValidatePausesSubKey('canFilterReviewed')){
            <button (click)="changeFilterStatus('ALL')"
                [ngClass]="filterStatus === 'ALL' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">Todas</button>
            <button (click)="changeFilterStatus('REVIEWED')"
                [ngClass]="filterStatus === 'REVIEWED' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">Revisadas</button>
            }
            <button (click)="changeFilterStatus('NO_REVIEWED')"
                [ngClass]="filterStatus === 'NO_REVIEWED' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">No
                revisadas</button>
        </div>

        <!-- Dates Input -->
        <div class="flex gap-2 justify-center items-center">
            <div>
                <nz-date-picker [nzDisabledDate]="disabledDate" nzShowTime nzFormat="dd/MM/yyyy HH:mm"
                    [nzShowTime]="{ nzDefaultOpenValue: timeDefaultValue, nzFormat:'HH:mm' }" [(ngModel)]="fromDate"
                    nzPlaceHolder="Desde" id="fromDate" (ngModelChange)="onChangeDatePickers()"
                    class="mx-2"></nz-date-picker>
                <nz-date-picker #endDatePicker [nzDisabledDate]="disabledDate" nzShowTime nzFormat="dd/MM/yyyy HH:mm"
                    [nzShowTime]="{ nzDefaultOpenValue: timeDefaultValue, nzFormat:'HH:mm' }" [(ngModel)]="toDate"
                    nzPlaceHolder="Hasta" id="toDate" (ngModelChange)="onChangeDatePickers()"
                    class="mx-2"></nz-date-picker>
            </div>
        </div>
        <!-- Search Input -->
        <div class="flex gap-2 justify-center lg:justify-end items-center">
            <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="clearSearchInput"
                class="rounded-lg border border-gray-300" style="width: 250px">
                <input onfocus="select()"
                    class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Orden / Proceso / Motivo / Obs. pausa" nz-input [(ngModel)]="filterText"
                    (keydown.enter)="getPaginatedPauses()" />
            </nz-input-group>
            <ng-template #clearSearchInput>
                @if (filterText) {
                <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                    nz-icon></span>
                }
            </ng-template>
            <ng-template #searchIcon>
                <span nz-icon nzType="search"></span>
            </ng-template>
        </div>
    </div>
</div>

<div #tableContainer class="p-4 h-[calc(100%_-_200px)] max-h-[calc(100%_-_200px)]">
    <nz-page-header class="text-[16px] font-semibold p-0 py-4" nzTitle="Pausas">
    </nz-page-header>
    <nz-table #pausesTable nzTableLayout="fixed" nzSize="small" [nzData]="pauses" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzTotal]="totalPauses" [nzBordered]="true" [nzFrontPagination]="false"
        [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }" nzShowSizeChanger [nzPageSize]="pageSize"
        [nzPageIndex]="pageIndex" (nzQueryParams)="onQueryParamsChange($event)">
        <thead>
            <tr>
                <th nzWidth="300px">Motivo</th>
                <th nzWidth="150px" nzColumnKey="startDate" [nzSortFn]="true" [nzSortOrder]="'descend'"
                    [nzSortDirections]="['ascend', 'descend']">Fecha inicio</th>
                <th nzWidth="125px" nzColumnKey="filterPausedBy" [nzShowFilter]="canReadPausesSubKey('canEditOtherUsers')"
                    [nzFilters]="filterPausedBy" [nzFilterFn]="true" [nzFilterMultiple]="true">Iniciada por</th>
                <th nzWidth="150px">Fecha fin</th>
                <th nzWidth="125px" nzColumnKey="filterResumedBy" [nzShowFilter]="canReadPausesSubKey('canEditOtherUsers')"
                    [nzFilters]="filterResumedBy" [nzFilterFn]="true" [nzFilterMultiple]="true">Reanudada por</th>
                <th nzWidth="100px">Duración</th>
                <th nzWidth="300px">Observaciones</th>
                <th nzWidth="300px">Orden | Proceso</th>
                @if(canEdit()){
                <th nzWidth="110px">Estado</th>
                <th nzWidth="110px" nzColumnKey="filterValidatedBy" [nzFilters]="filterValidatedBy" [nzFilterFn]="true"
                    [nzFilterMultiple]="true">Revisada por</th>
                <th nzWidth="150px">Fecha revisión</th>
                <th nzWidth="110px" nzColumnKey="filterAccepted" [nzFilters]="filterAccepted" [nzFilterFn]="true"
                    [nzFilterMultiple]="false">
                    ¿Aceptada?</th>
                }
                @if (canEdit() || canEditPauses()) {
                <th nzRight nzWidth="150px">Acciones</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (pause of pausesTable.data; track pause.id) {
            <tr [class]="pause.pauseReason ? '':'bg-red-100'">
                <td nzEllipsis [nzTooltipTitle]="pause.pauseReason?.name ?? 'Pausa pendiente de motivar'"
                    nzTooltipPlacement="bottom" nz-tooltip>{{
                    pause.pauseReason?.name ?? 'Pausa pendiente de motivar' }}</td>
                <td class="text-right">
                    {{pause.startDate | date: ("dd/MM/YYYY HH:mm:ss")}}
                </td>
                <td>{{ pause.pausedBy ? pause.pausedBy.name : "-" }}</td>
                <td class="text-right">
                    {{
                    pause.endDate === null
                    ? "-"
                    : (pause.endDate | date: ("dd/MM/YYYY HH:mm:ss"))}}
                </td>
                <td>{{ pause.resumedBy ? pause.resumedBy.name : "-" }}</td>
                <td class="text-right">
                    {{
                    pause.endDate === null
                    ? "-"
                    : milisecondsToFormatTime(
                    pause.startDate,
                    pause.endDate
                    )
                    }}
                </td>
                <td nzEllipsis [nzTooltipTitle]="pause.observations" nzTooltipPlacement="bottom" nz-tooltip>{{
                    pause.observations }}</td>
                <td nzEllipsis [nzTooltipTitle]=" 'Orden ' + (pause.productionOrderProcess?.productionOrder?.externalId ?
                pause.productionOrderProcess?.productionOrder?.externalId :
                pause.productionOrderProcess?.productionOrder?.id!) + '-' +
                pause.productionOrderProcess?.productionOrder?.description + ' | ' +
                pause.productionOrderProcess?.productionProcess?.name" nzTooltipPlacement="bottom" nz-tooltip>
                    {{ 'Orden ' + (pause.productionOrderProcess?.productionOrder?.externalId ?
                    pause.productionOrderProcess?.productionOrder?.externalId :
                    pause.productionOrderProcess?.productionOrder?.id!) + '-' +
                    pause.productionOrderProcess?.productionOrder?.description + ' | ' +
                    pause.productionOrderProcess?.productionProcess?.name}}
                </td>
                @if(canEdit()){
                <td>
                    <div class="flex items-center justify-center">
                        <span
                            [class]="(pause.validationDate ? 'bg-teal-100 text-teal-800 ' : 'bg-red-100 text-red-800 ') + 'font-semibold px-2.5 py-0.5 rounded text-xs'">
                            {{ pause.validationDate ? 'Revisada' : 'No revisada' }}
                        </span>
                    </div>
                </td>
                <td>{{ pause.validatedBy ? pause.validatedBy.name : "-" }}</td>
                <td class="text-right">
                    {{
                    pause.validationDate === null
                    ? "-"
                    : (pause.validationDate| date: ("dd/MM/YYYY HH:mm:ss"))}}
                </td>
                <td>
                    <div class="flex items-center justify-center">
                        <span
                            [class]="(pause.validationDate ? (pause.accepted ? 'bg-teal-100 text-teal-800 ' : 'bg-red-100 text-red-800 ') : 'bg-yellow-100 text-yellow-800 ') + 'font-semibold px-2.5 py-0.5 rounded text-xs'">
                            {{ pause.validationDate ? (pause.accepted ? 'Sí' : 'No') : '-' }}
                        </span>
                    </div>
                </td>
                }
                @if (canEdit() || canEditPauses()) {
                <td nzRight>
                    <div class="flex align-middle justify-center">
                        @if (canEditPauses()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Editar pausa'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="editPause(pause)" [disabled]="!pause.validatedBy ? (!canReadPausesSubKey('canEditOtherUsers') && (userLogged.id !== pause.pausedById || userLogged.id !== pause.resumedById)) : true">
                            <span nz-icon nzType="form"></span>
                        </button>
                        @if(canEdit()){
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }
                        @if(canEdit()){
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="!pause.validatedBy ? 'Aceptar pausa' : (pause.accepted ? 'Pausa aceptada' : 'Aceptar pausa')"
                            nzTooltipPlacement="bottom" nz-tooltip (click)="validateById(pause.id!,true)"
                            [disabled]="pause.pauseReason ? (!pause.validatedBy ? false : (pause.accepted ? true : false)) :true">
                            <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#36D399"></span>
                        </button>
                        <nz-divider nzType="vertical"></nz-divider>
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="!pause.validatedBy ? 'No aceptar pausa' : (pause.accepted ? 'No aceptar pausa' : 'Pausa no aceptada') "
                            nzTooltipPlacement="bottom" nz-tooltip (click)="validateById(pause.id!,false)"
                            [disabled]="pause.pauseReason ? (!pause.validatedBy ? false : (pause.accepted ? false : true)) :true">
                            <span nz-icon nzType="close-circle" nzTheme="twotone" nzTwotoneColor="#F87272"></span>
                        </button>
                        }
                    </div>
                </td>
                }
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>